import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import Home from "./Home";
import ChatGPTPage from "./ChatGPTPage";
import Header from "./components/home/Header";
import AiChatPage from "./AiChatPage";
import AiChatHistory from "./components/ai-assitance/AiHistoryDetailSection";
import MapView from "./MapView";
import OfficeSpacePage from "./OfficeSpacePage";
import ContactUsPage from "./ContactUsPage";
import {
  PrivateRouteAfterLogin,
  PrivateRoutePropertyData,
} from "./components/common/PrivateRouter";
import { useTranslation } from "react-i18next";

function LanguageRouter({ children }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.startsWith('/en')) {
      if (i18n.language !== 'en') i18n.changeLanguage('en');
    } else {
      if (i18n.language !== 'ro') i18n.changeLanguage('ro');
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* English routes */}
      <Route path="/en/*" element={
        <>
          <Header />
          <Routes>
            <Route path="" element={<Home />} />
            <Route path="consult" element={<PrivateRouteAfterLogin element={<ChatGPTPage />} />} />
            <Route path="ai-chat" element={<PrivateRoutePropertyData element={<AiChatPage />} />} />
            <Route path="chat-history" element={<PrivateRouteAfterLogin element={<AiChatHistory />} />} />
            <Route path="map-view" element={<PrivateRouteAfterLogin element={<MapView />} />} />
            <Route path="office-space" element={<OfficeSpacePage />} />
            <Route path="contact-us" element={<ContactUsPage />} />
            <Route path="*" element={<Navigate to="/en" replace />} />
          </Routes>
        </>
      } />
      {/* Romanian (default) routes */}
      <Route path="/*" element={
        <>
          <Header />
          <Routes>
            <Route path="" element={<Home />} />
            <Route path="consult" element={<PrivateRouteAfterLogin element={<ChatGPTPage />} />} />
            <Route path="ai-chat" element={<PrivateRoutePropertyData element={<AiChatPage />} />} />
            <Route path="chat-history" element={<PrivateRouteAfterLogin element={<AiChatHistory />} />} />
            <Route path="map-view" element={<PrivateRouteAfterLogin element={<MapView />} />} />
            <Route path="office-space" element={<OfficeSpacePage />} />
            <Route path="contact-us" element={<ContactUsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <LanguageRouter>
        <AppRoutes />
      </LanguageRouter>
    </Router>
  );
}
